<template>
  <v-container fluid grid-list-md>
    <!-- INICIOOOO Mensagem para entrar em contato com o suporte quando tenta cancelar assinaturas do gerencianet -->
    <v-dialog v-model="dialogGerencianetCancel" persistent scrollable :width="$vuetify.breakpoint.smAndDown ? '' : '600'">
      <v-card>
        <v-card-title primary-title>
          <span class="headline">Solicitação de Cancelamento</span>
          <v-btn icon style="right: 0; position: absolute" slot="activator" fab @click="dialogGerencianetCancel=false">
            <v-icon color="#444">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid grid-list-xs>
            <h3>Entre em contato com nosso suporte ao lado direito, ou pelas opções abaixo, para cancelar sua assinatura!</h3>
            <br>
            <span><strong>Telefone: </strong><strong style="color: blue;">(34) 99910-0135</strong></span><br>
            <span><strong>Email: </strong><strong style="color: blue;">suporte.sistema@illissolucoes.com.br</strong></span>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- FIMMMM Mensagem para entrar em contato com o suporte quando tenta cancelar assinaturas do gerencianet -->

    <p-confirm text="Após o cancelamento, você terá acesso a este plano até a data de expiração. Tem certeza que deseja cancelar essa Assinatura" :dialog="dialogConfirm" @confirm="confirmCancel()" @cancel="closeDialogDelete"></p-confirm>
    <p-confirm :text="`Para fazer o upgrade da empresa ${company.id_text}, é preciso estar logado nela. Deseja ir para essa empresa`" :dialog="dialogSignPlan" @confirm="signPlan" @cancel="closeDialogSignPlan"></p-confirm>
    <v-layout wrap justify-center align-center>
      <v-flex xs12 sm6 align-left>
        <span class="headline">Faturas</span>
        <!-- <v-btn class="mx-2" color="primary darken-2" @click="cancelSubscription()">Cancelar assinatura</v-btn> -->
      </v-flex>
      <!-- <v-flex xs12 sm6>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex> -->

      <v-flex  xs12 sm6 class="text-xs-right">
        <v-dialog v-model="dialogPaymentCancel" width="500" v-if="last_payment" persistent scrollable min-width="450">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on">Cancelar</v-btn>
          </template>

          <v-card>
            <v-card-title class="headline">
              Não vá embora ainda...
            </v-card-title>
            <v-card-text>
              <v-form v-model="validCancel" @keyup.native.ctrl.enter="dialogDelete(last_payment)" ref="form">
                <v-layout wrap justify-center align-center>

                  <v-flex>
                    <div class="body-2 mb-3">Valorizamos sua experiência. Antes de partir, nos conte o que podemos melhorar.</div>
                  </v-flex>

                  <v-flex xs12>
                    <v-select :items="itemsPaymentCancel" v-model="cancelEditedItem.cancel_id" @change="getIdText"
                      :label="translate('table.payment_cancel.field.cancel_id')" outline :rules="requiredRule(translate('table.payment_cancel.field.cancel_id'))"></v-select>
                  </v-flex>

                  <v-flex xs12>
                    <v-textarea v-model="cancelEditedItem.id_text" :label="translate('table.payment_cancel.field.id_text')"
                      outline :rules="cancelEditedItem.cancel_id == 1 ? requiredRule(translate('table.payment_cancel.field.id_text'), 5000) : []"></v-textarea>
                  </v-flex>
                </v-layout>
              </v-form>

              <v-divider></v-divider>

              <v-card-actions>
                <v-btn id="fechar" depressed @click="dialogPaymentCancel = false">
                  Desistir de cancelar
                </v-btn>
                <v-btn color="primary" depressed @click="dialogDelete(last_payment)">
                  Finalizar o cancelamento
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-tooltip v-else bottom>
          <v-btn :disabled="loading" @click="checkCompany" :loading="loading" slot="activator" color="primary" class="mb-4">
            Assinar
            <img src="https://img.icons8.com/color/48/000000/fairytale.png" height="30px"> &nbsp;
          </v-btn>
          <span>{{ 'Fazer Assinatura' }}</span>
        </v-tooltip>
        <v-dialog v-model="dialogAfterCancel" @keydown.enter="dialogAfterCancel = false" @keydown.esc="dialogAfterCancel = false" persistent max-width="300" scrollable>
          <v-card>
            <v-card-text justify-center>
              <p class="text-md-center">Cancelamento feito com sucesso!</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn id="after_confirm" class="mx-0" :loading="loading" flat color="primary" @click.native="dialogAfterCancel = false">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <!--Index-->
      <!-- :search="search" -->
      <v-flex xs12>
        <v-data-table
          :loading="loading"
          :no-data-text="translate('system.table.emptyTable')"
          rows-per-page-text="Registros por página"
          :headers="headers"
          :items="items"
          hide-actions
          disable-initial-sort
          :rows-per-page-items="[25,50,100,{'text':'Todos','value':-1}]"
          class="elevation-1">
          <v-progress-linear slot="progress" color="blue" indeterminate height="2"></v-progress-linear>
          <template slot="items" slot-scope="props">
            <td>{{ `${props.item.user.id_text} (${props.item.user.email})`}}</td>
            <td>{{ translate('value.payment_method').some((val) => {return val.value === props.item.payment_method}) ? translate('value.payment_method').find((val) => {return val.value === props.item.payment_method}).text : '' }}</td>
            <!-- <td>R$ {{ props.item.value.toFixed(2) }}</td> -->
            <td>{{ props.item.plan.id_text }}</td>
            <td>{{ props.item.due_date ? (props.item.due_date) : '' | formatDate }}</td>
            <td>{{ props.item.expired ? (props.item.expired) : '' | formatDate }}</td>
            <td>{{ (translate('value.payment_status').some((val) => {return val.value === props.item.payment_status}) ? translate('value.payment_status').find((val) => {return val.value === props.item.payment_status}).text : '') }}</td>
            <td align="center">
              <v-tooltip v-if="props.item.payment_status === 'RECEIVED' || props.item.payment_status === 'CONFIRMED' || props.item.payment_status === 'RECEIVED_IN_CASH'"  bottom>
                <v-btn slot="activator" icon class="mx-0" @click="viewReceipt(props.item.id)">
                  <v-icon color="black">receipt</v-icon>
                </v-btn>
                <span>Baixar nota fiscal</span>
              </v-tooltip>
              <v-tooltip v-else-if="last_payment && (last_payment.id === props.item.id) && props.item.payment_method === 'BOLETO'" bottom>
                <v-btn slot="activator" icon class="mx-0" @click="viewBillet(props.item.billet_url)">
                  <v-icon color="black">poll</v-icon>
                </v-btn>
                <span>Visualizar boleto</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style scoped>
</style>

<script>
  import crud from '../../mixin/crud'
  import PConfirm from '../shared/PConfirm'
  import rules from '../../mixin/rules'
  /* eslint-disable eqeqeq, no-unneeded-ternary */
  export default {
    name: 'Payment',
    props: ['company'],
    mixins: [rules, crud],
    components: {PConfirm},
    data: () => ({
      entity: 'payments',
      validCancel: false,
      dialogSignPlan: false,
      dialogGerencianetCancel: false,
      dialogPaymentCancel: false,
      loading: false,
      last_payment: false,
      dialogAfterCancel: false,
      items: [],
      itemsPaymentCancel: [{value: 2, text: 'Não tive tempo para estruturar'}, {value: 3, text: 'Minha equipe não se adaptou'}, {value: 4, text: 'O sistema é muito complexo'}, {value: 5, text: 'Questões financeiras'}, {value: 6, text: 'Não tive suporte'}, {value: 7, text: 'Não resolveu meu problema'}, {value: 1, text: 'Outros'}],
      // ['Não tive tempo para estruturar', 'Minha equipe não se adaptou', 'O sistema é muito complexo', 'Questões financeiras', 'Não tive suporte', 'Não resolveu meu problema'],
      editedItem: {},
      cancelEditedItem: {user_id: null, cancel_id: null, id_text: ''}
    }),
    created () {
      this.loading = true
      this.cancelEditedItem.user_id = this.$auth.user().id
      this.$http.get(`api/get_invoices/${this.company.id}`).then((res) => {
        this.items = res.body
        this.loading = false
        this.getLastPayment()
      })
    },
    methods: {
      checkCompany () {
        if (this.company.id !== this.$auth.user().company_id) {
          this.dialogSignPlan = true
        } else {
          this.$router.push('/upgrade')
        }
      },
      getIdText (valueId) {
        let itemPaymentCancel = this.itemsPaymentCancel.find((itemPaymentCancel) => itemPaymentCancel.value === valueId)
        if (itemPaymentCancel) {
          this.cancelEditedItem.id_text = itemPaymentCancel['value'] == 1 ? '' : itemPaymentCancel['text']
        }
      },
      closeDialogSignPlan () {
        this.dialogSignPlan = false
      },
      confirmCancel () {
        if ((this.$refs.form && !this.$refs.form.validate())) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'warning',
            dialog: true
          })
          this.dialogConfirm = false
          return false
        }
        this.$http.post(`api/payment_cancel`, this.cancelEditedItem).then(res => {
          this.dialogPaymentCancel = false
          this.cancelSubscription()
        }, err => {
          this.dialogConfirm = false
          this.dialogPaymentCancel = false
          console.log(err)
        })
      },
      signPlan () {
        this.$store.commit('loader/change_dialog', true)
        this.$http.post('auth/change-company', {'company_id': this.company.id}).then(res => {
          // volta para a home e da um reload na pagina para atualizar a company
          this.$socket.emit('generalEvent', {
            data: {text: `Você fez login em outra empresa. Será necessário recarregar a página.`},
            responseEvent: 'reloadPage',
            room: `user${this.$auth.user().id}`
          })
          this.$router.push('upgrade')
          setTimeout(() => {
            location.reload()
          }, 200)
        })
      },
      /**
       * Método para cancelar a assinatura do cliente.
       */
      cancelSubscription () {
        // Existem alguns usuários que estão com a forma antiga de pagamento (gerencianet), portanto os que tentarem cancelar deve aparecer uma msg, pois agora o cancelamento está configurado para o Asaas
        if (this.editedItem['payment_type'] === 'gerencianet') {
          document.getElementById('purechat-btn').click()
          this.dialogGerencianetCancel = true
        } else {
          this.$store.commit('loader/change_dialog', true)
          this.$http.put(`api/cancel_subscription/${this.editedItem.subscription_id}`).then(res => {
            this.$store.commit('loader/change_dialog', false)
            this.dialogConfirm = false
            if (res.body.hasOwnProperty('errors')) {
              this.$store.commit('snackbar/change_values', {
                text: 'Não foi possível efetuar o cancelamento! Entre em contato com nosso suporte.',
                timeout: 10000,
                color: 'error',
                dialog: true
              })
              document.getElementById('purechat-btn').click()
              this.dialogGerencianetCancel = true
              return
            }
            Object.assign(this.items.find((val) => { return val.id == this.last_payment.id }), { status: 'CANCELED' })
            this.dialogAfterCancel = true
            this.getLastPayment()
            // Atualiza a página
            location.reload()
          }, err => {
            console.log('err', err)
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível cancelar a Assinatura, reporte o erro.',
              color: 'error',
              dialog: true
            })
            this.dialogConfirm = false
          })
        }
      },
      getLastPayment () {
        if (this.items.length > 0) {
          var lastDate = this.items.find((val) => { return val.status === 'NEW' || val.status === 'ACTIVE' })
          this.last_payment = lastDate ? lastDate : false
        }
      },
      viewBillet (url) {
        window.open(url.toString(), '_blank')
      },
      viewReceipt (id) {
        this.$store.commit('loader/change_dialog', true)
        this.$http.get(`api/payment_bills/${id}`).then(res => {
          this.$store.commit('loader/change_dialog', false)
          window.open(process.env.API + 'uploads/NF/' + res.body.receipt_url, '_blank')
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possível baixar essa nota. Favor entrar em contato com nosso suporte!',
            color: 'error',
            dialog: true
          })
        })
      }
    },
    computed: {
      headers: function () {
        return [
          {text: this.translate(`table.${this.entity}.field.user_id`), value: 'user.id_text'},
          {text: this.translate(`table.${this.entity}.field.payment_method`), value: 'payment_method'},
          // {text: this.translate(`table.${this.entity}.field.value`), value: 'value'},
          {text: this.translate(`table.${this.entity}.field.plan_id`), value: 'plan.id_text'},
          {text: this.translate(`table.payment_bills.field.due_date`), value: 'due_date'},
          {text: this.translate(`table.payment_bills.field.expired`), value: 'expired'},
          {text: this.translate(`table.payment_bills.field.payment_status`), value: 'payment_status'},
          {text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center'}
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/details/CompanyPayment.vue